import { render, staticRenderFns } from "./Badges.vue?vue&type=template&id=fff6e940&scoped=true"
import script from "./Badges.vue?vue&type=script&lang=js"
export * from "./Badges.vue?vue&type=script&lang=js"
import style0 from "./Badges.vue?vue&type=style&index=0&id=fff6e940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff6e940",
  null
  
)

export default component.exports